import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./adminLogin.css";

function AdminLogin() {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {

    if (!username || !password) {

      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please enter username and password"
      });

      return;
    }

    try {

      setLoading(true);

      Swal.fire({
        title: "Logging in...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await fetch("https://lismount-api.onrender.com/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username,
          password
        })
      });

      const data = await response.json();

      Swal.close();

      if (data.status === "success") {

        await Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: "Welcome to Admin Dashboard",
          timer: 1500,
          showConfirmButton: false
        });

        localStorage.setItem("adminAuth", "true");

        navigate("/admin-dashboard");

      } else {

        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: "Invalid username or password"
        });

      }

    } catch (error) {

      console.error("Login error:", error);

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Unable to connect to server"
      });

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="admin-login-wrapper">

      <div className="admin-login-card">

        <h2 className="login-title">Admin Login</h2>

        <p className="login-subtitle">
          Secure access to dashboard
        </p>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="login-input"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
        />

        <button
          onClick={handleLogin}
          disabled={loading}
          className="login-button"
        >
          {loading ? "Logging in..." : "Login"}
        </button>

      </div>

    </div>

  );

}

export default AdminLogin;